import React from "react";
import './Home.css'


function Home() {

    return(
        <>
       <div className="banner-section">
            <div className="items">
        
                <h1>GOOD TRAVELLING </h1>
                <p>If you're going from one place to another, you're travelling.
                     People love to go travelling to see new places and experience different cultures.</p>
                <button className="btn1">Read More</button>
          
            </div>
        </div>

        
        </>
    )
    
}
export default Home